module.exports = __webpack_public_path__ + "static/endpoint-teal-4cc073f776c4bfad213ec0e0c049ad2d.png";